let paymethodlist = ["Bank Transfer", "Cash", "KNET", "Cheque", "Online Link"];
export default paymethodlist;
